import React from 'react'
import { COMTRUEVAR } from '../default/ocr_variables'
import {
    getLocalDateTime,
    getRandomNumber,
    getUserData,
    getAppMode,
} from 'app/shared/utils/comUtil'
import { showAlert } from 'app/shared/utils/util'
import { closeThis } from 'assets/resources/comtrue/js/default/common'

export const getCommonHeader = () => {
    const appMode = getAppMode()
    const csrfToken = getUserData('tkn', false)
    const screId = window.location.pathname.slice(1) // 화면번호
    const rqstYmd = getLocalDateTime('YYYYMMDD')
    const rqstHms = getLocalDateTime('hhmmssn')
    const trnRqstTs = rqstYmd + rqstHms
    let sysEnvrDcd = 'D'

    if (appMode === 'production') sysEnvrDcd = 'P'
    else if (appMode === 'test') sysEnvrDcd = 'T'

    // 글로벌ID 채번 규칙 : 전송일자(8) + 망구분(1) + 시스템코드(3) + 업무구분코드(3) + 일련번호(1) + 전송일시(9) + 랜덤시퀀스(5) + 진행구분번호(4) = 34 byte
    const guid =
        rqstYmd +
        sysEnvrDcd +
        'UIB' +
        'MAO' +
        '1' +
        rqstHms +
        getRandomNumber(5) +
        '0000'

    const reqHeader = {
        guid: guid, // GUID
        traceId: '', // 트레이스ID
        rqstSysDcd: 'UIB', // 요청시스템구분코드
        rqstSysBswrDcd: 'MAO', // 요청시스템업무구분코드
        clntIp: '', // 클라이언트IP     - 공백 고정
        clntMac: '', // 클라이언트MAC   - 공백 고정
        userIdntNo: '', // 사용자ID     - 공백 고정
        sysEnvrDcd: sysEnvrDcd, // 시스템환경구분코드
        trnRqstTs: trnRqstTs, // 거래요청일시
        trnMctm: '', // 거래유지시간
        screId: screId.split('/').includes('gw')
            ? 'gw'
            : screId.split('/').pop(), // 화면번호
        lnggDcd: 'ko', // 언어구분코드
        tkn: csrfToken, // 토큰
    }

    return reqHeader
}

export const uploadImageByBlob = async ({
    blob,
    cardType,
    token,
    returnFile,
    returnFace,
    encryptView,
    liveness,
    sendData,
    afterUploadCallback,
}) => {
    const UPLOAD_URL = '/uib/mao/com/ath' // 사본검증서버 주소
    const blackErrorCodeList = [
        'E30006', // 세션정보가 유효하지 않습니다.
        'E39995', // 잘못된 유입경로입니다. IBK큐브 메인 화면으로 이동합니다.
        'BXCME00053',
        'BXCME00054',
        'BXCME00055',
        'BXCME00056',
        'BXCME00057',
        'BXCME00058',
        'BXCME00059',
        'BXCME00060',
        'BXCME00061',
        'BXCME00062',
        'BXCME00063',
        'BXCME00064',
        'BXCME00065',
        'BXCME00066',
        'BXCME00067',
        'BXCME00068',
        'BXCME00069',
        'BXCME00070',
    ]
    const formData = new FormData()
    formData.append('file', blob, 'image.jpg') // 이름 지정 가능
    formData.append('cardType', cardType)
    formData.append('token', token)
    formData.append('returnFile', returnFile)
    formData.append('returnFace', returnFace)
    formData.append('encryptView', encryptView)
    formData.append('idReal', liveness)
    formData.append('license', COMTRUEVAR.licenseKey)
    if (encryptView) {
        // rsaKeys 전달 시 json 변환 추가
        formData.append('rsaKeys', JSON.stringify(COMTRUEVAR.rsaKeys))
    }
    formData.append('uploadUrl', `${UPLOAD_URL}/ath02/ath0202`)

    // [2025.06.10] 업로드 변수 추가
    formData.append('resData', COMTRUEVAR.resData)
    formData.append('initTime', COMTRUEVAR.initTime)
    formData.append('captureCount', COMTRUEVAR.captureCount)
    formData.append('blurScore', COMTRUEVAR.blurScore)
    formData.append('file', sendData)

    try {
        let commonHeader = getCommonHeader()
        let headerString = JSON.stringify(commonHeader)
        const response = await fetch(`${UPLOAD_URL}/ath02/ath0202`, {
            method: 'POST',
            headers: {
                'x-ibk-systemheader': window.btoa(headerString),
            },
            body: formData,
        })

        if (!response.ok) {
            const errorText = await response.json()
            if (!errorText.msgCd) {
                showAlert({
                    msg: errorText.bscMsg,
                    onConfirm: () => closeThis(),
                })
                return
            } else if (blackErrorCodeList.includes(errorText.msgCd)) {
                showAlert({
                    msg: errorText.bscMsg,
                    onConfirm: () => closeThis(),
                })
                return
            } else {
                showAlert({
                    msg: errorText.bscMsg,
                    onConfirm: () => closeThis(),
                })
                return
            }
        }

        const data = await response.json()

        if (afterUploadCallback) {
            afterUploadCallback(data) // 업로드 성공 후 콜백 실행
        }
    } catch (error) {
        console.error('업로드 중 에러 발생:', error)
    }
}

export default uploadImageByBlob
